import * as React from 'react'

import { TQPaymentStatusVariables, useQPaymentStatus } from '~graphql/generated/clientGraphql'

import { useOrderIdCtx } from '../../Order'

type TOptions = {
  orderId: Nullable<ID>
}

/**
 * Q the payment status of an order & returns the result/presents errors.
 * Used eg. after the user returns from an online payment gate
 * to check on our BE if the payment was successful.
 */
export const usePaymentStatus = (options?: TOptions) => {
  const orderIdContext = useOrderIdCtx()

  const orderId = React.useMemo(() => {
    return options?.orderId ?? orderIdContext.orderId ?? null
  }, [options?.orderId, orderIdContext.orderId])

  const variables = React.useMemo<TQPaymentStatusVariables | undefined>(() => {
    return orderId ? { orderId } : undefined
  }, [orderId])

  // Q the payment status on our BE
  const { data, loading: isFetching } = useQPaymentStatus({
    variables,
    skip: !variables,
    fetchPolicy: 'network-only',
  })

  const paymentStatus = React.useMemo(() => {
    if (!data) {
      return null
    }

    return data.status
  }, [data])

  return { paymentStatus, isFetching, orderId }
}
